import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { TabPanel, TabContext } from '@mui/lab';
import { alpha, useTheme } from '@mui/material/styles';
import { Tab, Box, Card, Tabs, Stack, Container, CardHeader } from '@mui/material';

import AppDiscoveryImg1 from '../../assets/appDiscovery/AppDiscovery1.png';
import AppDiscoveryImg2 from '../../assets/appDiscovery/AppDiscovery2.png';

const AppDiscovery = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState('discover');
  const TABS = [
    { value: 'discover', label: 'Discover', color: 'success' },
    { value: 'list', label: 'List', color: 'success' },
  ] as const;

  const handleActiveTabChange = (event: any, value: any) => {
    setActiveTab(value);
  };
  return (
    <>
      <Helmet>
        <title> Dashboard: App Discovery</title>
      </Helmet>

      <Container sx={{ maxWidth: '100% !important' }}>
        <Card>
          <CardHeader title="App Discovery" sx={{ mb: 2 }} />
          <TabContext value={activeTab}>
            <Tabs
              value={activeTab}
              onChange={handleActiveTabChange}
              sx={{
                px: 2.5,
                boxShadow: `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
              }}
            >
              {TABS?.map((tab: any) => (
                <Tab key={tab.value} value={tab.value} label={tab.label} iconPosition="end" />
              ))}
            </Tabs>
            <Stack spacing={2}>
              <TabPanel key={0} value="discover">
                <Box
                  component="img"
                  src={AppDiscoveryImg1}
                  sx={{ width: '80vw', height: '80vh', cursor: 'pointer' }}
                />
              </TabPanel>
              <TabPanel key={1} value="list">
                <Box
                  component="img"
                  src={AppDiscoveryImg2}
                  sx={{ width: '80vw', height: '80vh', cursor: 'pointer' }}
                />
              </TabPanel>
            </Stack>
          </TabContext>
        </Card>
      </Container>
    </>
  );
};

export default AppDiscovery;
